import React, { useEffect } from 'react';
import { Title, BizonSidebar, Button } from 'components/commons';
import { useAntiFraudConsumer } from './hooks';
import LivenessExplanationModal from './liveness-explanation-modal';
import LivenessStatusBar from './components/liveness-status-bar';
import './bizon-checkout.styles.scss';

type LivenessCheckoutProps = {
    nextScreenButtonLoading?: boolean,
    nextScreenButtonDisabled?: boolean,
    nextScreen(): void,
};

const LivenessCheckout: React.FC<LivenessCheckoutProps> = ({
    nextScreenButtonLoading = false,
    nextScreenButtonDisabled = false,
    nextScreen,
}): JSX.Element => {
    const { antiFraud, borrowerPosition, refetch } = useAntiFraudConsumer();

    useEffect(() => {
        refetch();
    }, [antiFraud]);

    return (
        <div className="bizon-checkout grid-container">
            <BizonSidebar
                initialClosed={true}
                className="bizon-checkout__sidebar"
                mainTitle={<>falta pouco! não deixe sua <br /> oferta pré-aprovada expirar</>}
                boxTitle={<>caso tenha dúvidas, entre em contato pelos canais abaixo:</>}
            />
            <div className="bizon-checkout__content">
                <Title className="mt-4 lowercase">
                    oi, que bom que<br className="hidden-lg" /> você está aqui!
                </Title>

                <p className="body-1 mt-3">
                    Para manter a segurança precisamos conferir alguns dados.
                </p>

                <LivenessStatusBar
                    antiFraud={antiFraud}
                    borrowerPosition={borrowerPosition}
                />

                <LivenessExplanationModal />
            </div>
            <div className="bizon-checkout__footer">
                <Button
                    type="button"
                    disabled={nextScreenButtonDisabled}
                    loading={nextScreenButtonLoading}
                    className="btn-biz primary"
                    label="vamos começar"
                    onClick={() => nextScreen()}
                />
            </div>
        </div>
    );
};

export default LivenessCheckout;
